import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavigationTile from 'components/shared/NavigationTile';

import type { Collection, CollectionName } from 'domains/photos';

type CollectionTileProps = {
  collection: Collection;
  onSelect: (collection: CollectionName) => void;
  onOpen: (collection: CollectionName) => void;
  onDelete: (collection: string) => void;
  onEdit: (collection: CollectionName) => void;
};

function CollectionTile(props: CollectionTileProps) {
  const { collection, onSelect, onOpen, onDelete, onEdit } = props;

  const collectionName = useMemo(() => collection.name || 'Uncollected', [collection]);

  function tileDetails(imageCount: number) {
    return `${imageCount} ${imageCount !== 1 ? 'images' : 'image'}`;
  }

  return (
    <NavigationTile
      item={{ ...collection, id: collectionName }}
      image={collection.thumb || undefined}
      name={collectionName}
      details={tileDetails(collection.count)}
      className="collection"
      clickHandler={() => onOpen(collection.name)}
      menuItems={[
        {
          label: (
            <span>
              Open <span className="screen-reader-text">{collectionName}</span>
            </span>
          ),
          icon: <FontAwesomeIcon icon="folder-open" />,
          click: () => onOpen(collection.name),
        },
        {
          label: (
            <span>
              Load <span className="screen-reader-text">{collectionName}</span>
            </span>
          ),
          icon: <FontAwesomeIcon icon="film" />,
          click: () => onSelect(collection.name),
        },
        {
          label: (
            <span>
              Delete <span className="screen-reader-text">{collectionName}</span>
            </span>
          ),
          disabled: collection.name === null,
          icon: <FontAwesomeIcon icon="trash-alt" />,
          click: () => {
            if (collection.name !== null) {
              onDelete(collection.name);
            }
          },
        },
        {
          label: (
            <span>
              Rename <span className="screen-reader-text">{collectionName}</span>
            </span>
          ),
          icon: <FontAwesomeIcon icon="edit" />,
          click: () => onEdit(collection.name),
        },
      ]}
    />
  );
}

export default CollectionTile;
